import request from '@/utils/request'

export const getProApplyList = (data) => {
    return request({
        url: '/proApply/list',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const delSelQuotationApply = (data) => {
    return request({
        url: '/apply/deleteApply',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const closeApplyInfo = (data) => {
    return request({
        url: '/apply/closeApply',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const getQuotationApplyInfo = (data) => {
    return request({
        url: '/proApply/info/' + data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
    });
}
export const getMaterial = (data) => {
    return request({
        url: '/material',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const createDetail = (id, data) => {
    return request({
        url: '/proApply/createDetail/' + id,
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const createApplyInfo = (data) => {
    return request({
        url: '/proApply/createApply',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const updateApplyInfo = (data) => {
    return request({
        url: '/proApply/update',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const submitApplyInfo = (data) => {
    return request({
        url: '/proApply/submitApply',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const delSelQuotationApplyPro = (data) => {
    return request({
        url: '/proApply/deleteDetail',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const getQuotationListData = (data) => {
    return request({
        url: '/productQuote/list',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const getApplyDetail = (data) => {
    return request({
        url: '/productQuote/init',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const roundInit = (data) => {
    return request({
        url: '/productQuote/roundInit',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
//产品预估年总费用
export const predictYearCost = (data) => {
    return request({
        url: '/productQuote/mcdSave',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const productQuoteSave = (data) => {
    return request({
        url: '/productQuote/save',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const createNewRound = (data) => {
    return request({
        url: '/productQuote/createNewRound',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const endQuotation = (data) => {
    return request({
        url: '/productQuote/closeQuotation',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const recoveryQuotation = (data) => {
    return request({
        url: '/productQuote/recoveryQuotation',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const getSourcingList = (data) => {
    return request({
        url: '/sourcing-product/querySubmit',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const searchSourcing = (data) => {
    return request({
        url: '/sourcing-product/search',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const sourcingSubmit = (data) => {
        return request({
            url: '/sourcing-product/submit',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    }
    //试算
export const calculates = (data) => {
    return request({
        url: '/calculates',
        method: 'get',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        params: data
    })
}

export const calculatesDetail = (data) => {
    return request({
        url: '/calculates/' + data,
        method: 'get',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },

    })
}
export const calculation = (data) => {
    return request({
        url: '/productQuote/getLine',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const saveData = (data, id) => {
    return request({
        url: '/calculates/' + id,
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const exportDetail=(quotationId)=> {
  return request({
      url: `productQuote/exportDetail/${quotationId}`,
      method: 'post',
      responseType: 'blob',
      fullResponse: true
  });
}